import { jsx, jsxs } from "react/jsx-runtime";
import { useContainer, useValue } from "@tldraw/editor";
import { Dialog as _Dialog } from "radix-ui";
import { memo, useCallback } from "react";
import { useDialogs } from "../context/dialogs.mjs";
import { useDirection } from "../hooks/useTranslation/useTranslation.mjs";
const TldrawUiDialog = ({ id, component: ModalContent, preventBackgroundClose }) => {
  const { removeDialog } = useDialogs();
  const container = useContainer();
  const dir = useDirection();
  const handleOpenChange = useCallback(
    (isOpen) => {
      if (!isOpen) {
        removeDialog(id);
      }
    },
    [id, removeDialog]
  );
  return /* @__PURE__ */ jsx(_Dialog.Root, { onOpenChange: handleOpenChange, defaultOpen: true, children: /* @__PURE__ */ jsxs(_Dialog.Portal, { container, children: [
    /* @__PURE__ */ jsx(_Dialog.Overlay, { dir, className: "tlui-dialog__overlay" }),
    /* @__PURE__ */ jsx("div", { dir, className: "tlui-dialog__positioner", children: /* @__PURE__ */ jsx(
      _Dialog.Content,
      {
        dir,
        className: "tlui-dialog__content",
        "aria-describedby": void 0,
        onInteractOutside: (e) => {
          if (preventBackgroundClose) {
            e.preventDefault();
          }
        },
        children: /* @__PURE__ */ jsx(ModalContent, { onClose: () => handleOpenChange(false) })
      }
    ) })
  ] }) });
};
const DefaultDialogs = memo(function DefaultDialogs2() {
  const { dialogs } = useDialogs();
  const dialogsArray = useValue("dialogs", () => dialogs.get(), [dialogs]);
  return dialogsArray.map((dialog) => /* @__PURE__ */ jsx(TldrawUiDialog, { ...dialog }, dialog.id));
});
export {
  DefaultDialogs
};
//# sourceMappingURL=Dialogs.mjs.map
